import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {white} from '/theme/color/on.color';

import ReportCardSubheading from '../ReportCardSubheading';

const overrideStyle = StyleSheet.create({
  container: {
    backgroundColor: white,
  },
});

storiesOf('base', module).add('ReportCardSubheading', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Report Card Subheading</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>ReportCardSubheading</Code> component is used to render
          additional information in Coach or Client report card. Basically, it's
          just a container with indents and formatted text inside.
        </Text>
        <Spacer size={16} />
        <Text>
          Passing JSX as a value might be used to apply additional styles or
          logic.
        </Text>
        <Spacer size={16} />
        <View style={overrideStyle.container}>
          <ReportCardSubheading
            label="Date joined"
            value={<Text>May 1, 2021</Text>}
          />
        </View>
        <Spacer size={16} />
        <Code>{'<ReportCardSubheading'}</Code>
        <Code>{'  label="Date joined"'}</Code>
        <Code>{'  value={<Text>May 1, 2021</Text>}'}</Code>
        <Code>{'/>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
